export default "__VITE_ASSET__C8_mVgnx__"